import VueRouter, { RouteConfig } from "vue-router";
import { scrollBehavior } from "../../common/src/utility/routerUtils";
import NotFoundView from "./views/NotFoundView.vue";
// import ExplorerToolView from "./views/ExplorerToolView.vue";
import OrganizationView from "./views/OrganizationView.vue";
import GeographicToolView from "./views/GeographicToolView.vue";
import GeographicToolSidebar from "./molecules/sidebars/desktopSidebars/GeographicToolSidebar.vue";
import IndustryAnalyticsView from "./views/IndustryAnalyticsView.vue";
import IndustryAnalyticsSidebar from "./molecules/sidebars/desktopSidebars/IndustryAnalyticsSidebar.vue";
import OrganizationSidebar from "./molecules/organization/views/OrganizationSidebar.vue";
import OrganizationOverview from "./molecules/organization/views/OrganizationOverview.vue";
import TechnicalOverview from "./molecules/organization/views/TechnicalOverview.vue";
import FinancialInformation from "./molecules/organization/views/FinancialInformation.vue";
import TeamOwnership from "./molecules/organization/views/TeamOwnership.vue";
import ProjectsPartners from "./molecules/organization/views/ProjectsPartners.vue";
import NewsEvents from "./molecules/organization/views/NewsEvents.vue";
import FlashNewsView from "./views/FlashNewsView.vue";
import FlashNewsSidebar from "./molecules/sidebars/desktopSidebars/FlashNewsSidebar.vue";
import QuiltyUserDashboardView from "./views/QuiltyUserDashboardView.vue";
import QuiltyInsightsSidebar from "./molecules/sidebars/desktopSidebars/QuiltyInsightsSidebar.vue";
import QuiltyInsightsView from "./views/QuiltyInsightsView.vue";
import { SidebarStore } from "../../common/src/stores/SidebarStore";
import { Container } from "inversify";
import { AuthGate } from "../../common/src/AuthGate";
import EventListView from "./views/EventListView.vue";
import GlobalEventsSidebar from "./molecules/sidebars/desktopSidebars/GlobalEventsSidebar.vue";
// import EArtworkView from "./views/EArtworkView.vue";
import UserDashboardView from "./views/UserDashboardView.vue";
import LaunchpadSidebar from "./molecules/sidebars/desktopSidebars/LaunchpadSidebar.vue";
import SectorCompanyReportsView from "./views/SectorCompanyReportsView.vue";
import ReportsSidebar from "./molecules/sidebars/desktopSidebars/ReportsSidebar.vue";
import TransactionsView from "./views/TransactionsView.vue";
import ReportsMobileSidebar from "./molecules/sidebars/mobileFilterModals/ReportsMobileSidebar.vue";
import FlashNewsMobileSidebar from "./molecules/sidebars/mobileFilterModals/FlashNewsMobileSidebar.vue";
import QuiltyInsightsMobileSidebar from "./molecules/sidebars/mobileFilterModals/QuiltyInsightsMobileSidebar.vue";
import GeographicToolMobileSidebar from "./molecules/sidebars/mobileFilterModals/GeographicToolMobileSidebar.vue";
import GlobalEventsMobileSidebar from "./molecules/sidebars/mobileFilterModals/GlobalEventsMobileSidebar.vue";
import IndustryAnalyticsMobileSidebar from "./molecules/sidebars/mobileFilterModals/IndustryAnalyticsMobileSidebar.vue";
import ProfileMobileNavigation from "./molecules/sidebars/mobileNavigations/ProfileMobileNavigation.vue";
import OrganizationMobileNavigation from "./molecules/sidebars/mobileNavigations/OrganizationMobileNavigation.vue";

import MyProfileSidebar from "./molecules/sidebars/desktopSidebars/MyProfileSidebar.vue";
import MyProfile from "./views/MyProfile.vue";
import PersonalInformation from "./molecules/myProfile/views/PersonalInformation.vue";
import Subscriptions from "./molecules/myProfile/views/Subscriptions.vue";
import Requests from "./molecules/myProfile/views/Requests.vue";
import Affiliations from "./molecules/myProfile/views/affiliations/Affiliations.vue";
import PasswordReset from "./molecules/myProfile/views/passwordReset/PasswordReset.vue";
import { AuthStore } from "../../common/src/stores/AuthStore";
import {
    hasActiveQuiltySubscription,
    getGseSubscription,
    getQuiltySubscription,
} from "@gsx/common";
import { OrganizationStore } from "./stores/organization/OrganizationStore";
import { event } from "vue-gtag";

export const createRouter = (container: Container): VueRouter => {
    const authGate: AuthGate = container.get(AuthGate);
    const sidebarStore: SidebarStore = container.get(SidebarStore);
    const authStore: AuthStore = container.get(AuthStore);
    const organizationStore = container.get(OrganizationStore);

    const routes: RouteConfig[] = [
        {
            path: "/",
            redirect: `/${getDefaultRoute()}`,
        },
        {
            path: "/profile",
            components: {
                default: MyProfile,
                sidebar: MyProfileSidebar,
                mobileNavigation: ProfileMobileNavigation,
            },
            children: [
                {
                    path: "",
                    component: PersonalInformation,
                    name: "profile",
                },
                {
                    path: "subscriptions",
                    component: Subscriptions,
                    name: "profile",
                },
                {
                    path: "requests",
                    component: Requests,
                },
                {
                    path: "affiliations",
                    component: Affiliations,
                    name: "profile",
                },
                {
                    path: "password-reset",
                    component: PasswordReset,
                    name: "profile",
                },
            ],
        },
        {
            path: "/member",
            components: {
                default: UserDashboardView,
                sidebar: LaunchpadSidebar,
            },
        },
        {
            path: "/quiltyDashboard",
            components: {
                default: QuiltyUserDashboardView,
                sidebar: LaunchpadSidebar,
            },
        },
        // {
        //     path: "/eArtwork",
        //     component: EArtworkView,
        // },
        {
            path: "/industry-analytics",
            beforeEnter: authGate.requireEnterpriseMembershipGuard(),
            components: {
                default: IndustryAnalyticsView,
                sidebar: IndustryAnalyticsSidebar,
                mobileFilterModal: IndustryAnalyticsMobileSidebar,
            },
        },
        {
            path: "/sector-company-reports",
            components: {
                default: SectorCompanyReportsView,
                sidebar: ReportsSidebar,
                mobileFilterModal: ReportsMobileSidebar,
            },
        },
        {
            path: "/quilty-quicktakes",
            components: {
                default: FlashNewsView,
                sidebar: FlashNewsSidebar,
                mobileFilterModal: FlashNewsMobileSidebar,
            },
        },
        {
            path: "/flash-news/:title",
            components: {
                default: FlashNewsView,
                sidebar: FlashNewsSidebar,
            },
        },
        {
            path: "/quilty-insights",
            components: {
                default: QuiltyInsightsView,
                sidebar: QuiltyInsightsSidebar,
                mobileFilterModal: QuiltyInsightsMobileSidebar,
            },
        },
        {
            path: "/quilty-insights/:title",
            components: {
                default: QuiltyInsightsView,
                sidebar: QuiltyInsightsSidebar,
            },
            beforeEnter: authGate.requireQuiltyMembershipGuard(),
        },

        // {
        //     path: "/explorer-tool",
        //     beforeEnter: authGate.requireMembershipGuard(),
        //     component: ExplorerToolView,
        // },
        {
            path: "/explorer-tool",
            components: {
                default: GeographicToolView,
                sidebar: GeographicToolSidebar,
                mobileFilterModal: GeographicToolMobileSidebar,
            },
        },
        {
            path: "/organizations/:organization",
            components: {
                default: OrganizationView,
                sidebar: OrganizationSidebar,
                mobileNavigation: OrganizationMobileNavigation,
            },
            beforeEnter: async (to, _, next) => {
                const organizationId = to.params.organization;

                if (to.path === `/organizations/${organizationId}/financial`) {
                    next();
                    return;
                }

                try {
                    await organizationStore.load(organizationId);
                    const organization = organizationStore.item;

                    if (organization) {
                        const financialDataExists =
                            (organization.keyPerformanceIndicators &&
                                organization.keyPerformanceIndicators.yearlyFinancialData &&
                                organization.keyPerformanceIndicators.yearlyFinancialData.length) ||
                            organization.reports.length ||
                            (organization.investments && organization.investments.length) ||
                            (organization.mergerAcquisitions &&
                                organization.mergerAcquisitions.length);

                        if (hasActiveQuiltySubscription(authStore.user) && financialDataExists) {
                            next(`/organizations/${organizationId}/financial`);
                        } else {
                            next();
                        }
                    } else {
                        next();
                    }
                } catch (err) {
                    next();
                }
            },
            children: [
                {
                    path: "",
                    component: OrganizationOverview,
                    name: "organizations",
                },
                {
                    path: "technical",
                    component: TechnicalOverview,
                    name: "organizations",
                },
                {
                    path: "financial",
                    component: FinancialInformation,
                    name: "organizations",
                },
                {
                    path: "team",
                    component: TeamOwnership,
                    name: "organizations",
                },
                {
                    path: "projects",
                    component: ProjectsPartners,
                    name: "organizations",
                },
                {
                    path: "news-and-events",
                    component: NewsEvents,
                    name: "organizations",
                },
            ],
        },
        {
            path: "/conferences/:conference?",
            components: {
                default: EventListView,
                sidebar: GlobalEventsSidebar,
                mobileFilterModal: GlobalEventsMobileSidebar,
            },
        },
        { path: "*", component: NotFoundView },
        {
            path: "/deals",
            component: TransactionsView,
            name: "deals",
        },
    ];

    function getDefaultRoute(): string {
        const host = window.location.host;
        const parts = host.split(".");

        return parts[0] === "quilty" ? "quiltyDashboard" : "member";
    }

    const router = new VueRouter({
        mode: "history",
        base: "/dashboard",
        linkActiveClass: "active",
        routes,
        scrollBehavior,
    });

    router.beforeEach(authGate.requireRegisteredGuard());
    router.afterEach(sidebarStore.close);

    // Add afterEach guard for Google Analytics
    router.afterEach(() => {
        event("user_tiers", {
            gse_subscription: getGseSubscription(authStore.user),
            quilty_subscription: getQuiltySubscription(authStore.user),
        });
    });

    return router;
};
